import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import SimpleParallax from "simple-parallax-js";
import Swiper from "swiper";

var images = document.querySelectorAll(".hero img");

new SimpleParallax(images, {
	scale: 1.1,
});

Array.from(document.querySelectorAll("section.hero .swiper")).map((hero) => {
	const swiper = new Swiper(hero, {
		modules: [Autoplay, Pagination, EffectFade],
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 7500,
		},
		loop: true,
	});
});

const elements = {
	floating_fab: document.getElementById("js-quick-booker-fab"),
};

document.addEventListener("DOMContentLoaded", () => {
	const hero = document.querySelector(".hero");

	// Exit early if no hero exists on this page
	if (!hero) return;

	// Create observer with sensible defaults
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				elements?.floating_fab &&
					elements?.floating_fab.setAttribute(
						"data-hidden",
						entry.isIntersecting ? "true" : "false"
					);
			});
		},
		{
			root: null, // observe relative to viewport
			threshold: 0.1, // 10% of hero visible counts as "in view"
		}
	);

	observer.observe(hero);
});
